@import '~style-sheet-helpers/core.less';
@import '../authentication.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.verify-form {
  color: @authentication--text-color;
  position: relative;
}

.verify-form-title {
  text-align: center;
  margin: 20px 0 5px;
  font-size: 17px;
}

.error-message {
  margin: 10px 0;
  background: @authentication--error--background-color;
  border: 1px solid @authentication--error--border-color;
  font-size: 13px;
  color: @authentication--error--text-color;
  border-radius: 4px;
  padding: 10px;
}

.loading-icon {
  height: 82px;
  margin: 50px 0;
}

.one-moment-please {
  margin-top: 10px;
}
